/** @format */

export const redux = [
  {
    title: 'Модуль 1 - Основы Redux',
    path: '/redux/1',
    items: [
      { title: 'Введение', path: '/redux/1/1' },
      { title: 'Основные принципы Redux', path: '/redux/1/2' },
      { title: 'Store', path: '/redux/1/3' },
      { title: 'Actions', path: '/redux/1/4' },
      { title: 'Reducers', path: '/redux/1/5' },
      { title: 'React и Redux', path: '/redux/1/6' },
      { title: 'Redux DevTools', path: '/redux/1/7' },
      { title: 'Организация хранилища', path: '/redux/1/8' },
      { title: 'Композиция редюсеров', path: '/redux/1/9' },
    ],
  },
  {
    title: 'Модуль 2 - Redux Toolkit',
    path: '/redux/2',
    items: [
      { title: 'Введение', path: '/redux/2/1' },
      { title: 'Использование Redux Toolkit', path: '/redux/2/2' },
      { title: 'Пример', path: '/redux/2/3' },
    ],
  },
  {
    title: 'Модуль 3 - Асинхронный Redux',
    path: '/redux/3',
    items: [
      { title: 'Redux middleware', path: '/redux/3/1' },
      { title: 'Асинхронность в Redux', path: '/redux/3/2' },
    ],
  },
  {
    title: 'Модуль 4 - Селекторы',
    path: '/redux/4',
    items: [
      { title: 'Введение', path: '/redux/4/1' },
      { title: 'Общие принципы мемоизации', path: '/redux/4/2' },
      { title: 'Reselect', path: '/redux/4/3' },
    ],
  },
  {
    title: 'Модуль 5 - Регистрация и логин',
    path: '/redux/5',
    items: [
      { title: 'JWT(JSON Web Token)', path: '/redux/5/1' },
      { title: 'Авторизация и аутентификация пользователя', path: '/redux/5/2' },
      { title: 'Защищенные ресурсы', path: '/redux/5/3' },
    ],
  },
]
